<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section>
<span aria-label="11" id="pg_11" role="doc-pagebreak">
<figure class="IMG"><img alt="" class="img90" src="images/Space_Station_Down_-_diagram_sketch_final_-_REVISED.jpg"/></figure>
<h1 class="PT" id="pt1"><span href="#/xhtml/contents#p_pt1" title="Link target outside of Sample">DAY ONE</span></h1>
</span></section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?23324edf